const addFeesReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_FEES": {
        return{
          ...state,
          addFeesSuccess: action.success
        }
      }
      case "ADD_FEES_ERR": {
        return{
          ...state,
          addFeesError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default addFeesReducer;
  